"use client";

import { Toaster as BaseToaster } from "@saridana-core/react-ui-kit";

export function Toaster() {
  return <BaseToaster />;
}
